import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
import React, { type ReactNode } from 'react';

// A resource's status reads as a tinted pill: a round icon on its own colour, with the status name
// beside it in the same colour. The three status axes share it so they line up in the table and a
// palette change lands on all of them at once.

// forwardRef because a caller may hang a Tooltip off the icon, and MUI needs a ref on its child.
export const ResourceStatusIcon = React.forwardRef((t0, ref) => {
  const $ = _c(17);
  let backgroundColor;
  let icon;
  let iconColor;
  let props;
  if ($[0] !== t0) {
    ({
      icon,
      iconColor,
      backgroundColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = icon;
    $[3] = iconColor;
    $[4] = props;
  } else {
    backgroundColor = $[1];
    icon = $[2];
    iconColor = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== iconColor) {
    t1 = {
      background: iconColor
    };
    $[5] = iconColor;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== backgroundColor || $[8] !== t1) {
    t2 = {
      background: backgroundColor,
      "& i": t1
    };
    $[7] = backgroundColor;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = `${icon} h-[20px] w-[20px]`;
  let t4;
  if ($[10] !== t3) {
    t4 = <i className={t3} />;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== ref || $[14] !== t2 || $[15] !== t4) {
    t5 = <Box ref={ref} {...props} component="span" className="rounded-full inline-flex p-[2px]" sx={t2}>{t4}</Box>;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
});

// icon is a node rather than a name so a caller can pass one that carries its own tooltip - the
// backup status hangs its violations breakdown off the icon.
export const ResourceStatusBadge = t0 => {
  const $ = _c(9);
  const {
    icon,
    label,
    iconColor,
    background
  } = t0;
  let t1;
  if ($[0] !== background) {
    t1 = {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      width: "fit-content",
      paddingLeft: "4px",
      paddingRight: "12px",
      borderRadius: "999px",
      background
    };
    $[0] = background;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== iconColor || $[3] !== label) {
    t2 = label && <Typography variant="subtitle2" sx={{
      background: iconColor,
      backgroundClip: "text",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    }}>{label}</Typography>;
    $[2] = iconColor;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== icon || $[6] !== t1 || $[7] !== t2) {
    t3 = <Stack direction="row" sx={t1}>{icon}{t2}</Stack>;
    $[5] = icon;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};